import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=7c968d23&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=7c968d23&prod&lang=less&scoped=true"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&id=7c968d23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c968d23",
  null
  
)

export default component.exports